import React, { useState, useEffect,useCallback } from 'react';
import axios from "axios";
import Select from 'react-select';
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";

const InformationsGenerales = (props) => {

	const objets = [
		{
			'key':"CONTACT",
			'label':"Sélectionnez"
		},
		{
			'key':"RAPPEL",
			'label':"À propos d'une formation"
		},
		{
			'key':"RAPPELINTRA",
			'label':"Organiser une formation intra-entreprise"
		},
		{
			'key':"CONTACT",
			'label':"Autre demande"
		}
	]
	const HandleChangeObjet = (obj) => {
		props.setObjet(obj)
	};

    useEffect(() => {

		if(props.selectedFormation != ''){
			props.setObjet(objets[1])
		}
		if(props.selectedMode == 'INTRA'){
			props.setObjet(objets[2])
		}
  	}, []);

	const renderAccepteRappel = () => {
		if(props.typeFormulaire == 'ENTREPRISE'){
			props.setAccepteRappel(true)
			props.setAccepteComCom(false)
		}else{

			return (
				<>
				
				<div className="col-12 pt-4">
					<div className="form-check">
						<input className="form-check-input" type="checkbox" value={true} id="entreprise_comcom" onChange={(e) => {  props.setAccepteComCom(e.target.checked)}} checked={props.accepteComCom} />
						<label for="entreprise_comcom" className="form-label">Je souhaite recevoir les offres et communications d'EI Groupe par e-mail.</label>
					</div>
					
				</div>
				<div className="col-12 pt-4">
					<div className="form-check">
						<input className="form-check-input" type="checkbox" value={true} id="entreprise_rappel" onChange={(e) => {  props.setAccepteRappel(e.target.checked)}} checked={props.accepteRappel} />
						<label for="entreprise_rappel" className="form-label">Je consens à être contacté par un conseiller par téléphone et/ou SMS. *</label>
					</div>
					
				</div>
				</>
			)
		}
	}

	return (
		<>
		<div className="row mt-3">
			<div className="col-12">
				
				<label for="objet" className="form-label">Objet de votre demande*</label>
					<Select
						onChange={(option) => HandleChangeObjet(option)}
						options={objets}
						placeholder="Sélectionnez"
						value={props.objet}
						defaultValue={props.objet}
						getOptionValue={option => option.key}
						getOptionLabel={(option) => option.label}
						required={true}
						className="react-select-container"
						classNamePrefix="react-select"



					/>
			</div>
		</div>
		<div className="row mt-3">
			<div className="col-12">
				<label for="message" className="form-label">Message*</label>
				<textarea className="form-control" name="message" id="message" required="true" onChange={(e) => {props.setMessage(e.target.value)}}></textarea>
			</div>
			{renderAccepteRappel()}
		</div>
		<p class="mentions mt-5 text-center">En remplissant ce formulaire, j’accepte l’usage de mes données pour le traitement de ma demande conformément à la <a href="/politique-de-confidentialite/">Politique de confidentialité</a>.</p>
		</>
	)
}
const InformationsEntreprise = (props) => {

	return (
		<>
		<div className="row">
			<div className="col-12 mt-3">
				<label for="entreprise_societe" className="form-label">Raison sociale*</label>
				<input className="form-control" type="text" name="societe" id="entreprise_societe" value={props.entrepriseSociete} required="true" onChange={(e) => {props.setEntrepriseSociete(e.target.value)}} />
			</div>
		</div>

		<div className="row">
			<div className="col-12 col-md-6 mt-3">
				<label for="entreprise_nom" className="form-label">Nom*</label>
				<input className="form-control" type="text" name="nom" id="entreprise_nom" value={props.entrepriseNom} required="true" onChange={(e) => {props.setEntrepriseNom(e.target.value)}} />
			</div>
			<div className="col-12 col-md-6 mt-3">
				<label for="entreprise_prenom" className="form-label">Prénom*</label>
				<input className="form-control" type="text" name="prenom" id="entreprise_prenom" value={props.entreprisePrenom} required="true" onChange={(e) => {props.setEntreprisePrenom(e.target.value)}} />
			</div>
		</div>
		<div className="row">
			<div className="col-12 col-md-6 mt-3">
				<label for="entreprise_telephoneMobile" className="form-label">Téléphone*</label>
				<input className="form-control" type="tel" name="telephoneMobile" id="entreprise_telephoneMobile" value={props.entrepriseTelephone} required="true" onChange={(e) => {props.setEntrepriseTelephone(e.target.value)}} pattern="^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$" />
			</div>
			<div className="col-12 col-md-6 mt-3">
				<label for="entreprise_email" className="form-label">E-mail*</label>
				<input className="form-control" type="email" name="email" id="entreprise_email" value={props.entrepriseEmail} required="true" onChange={(e) => {props.setEntrepriseEmail(e.target.value)}} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
			</div>
		</div>
		<div className="row">
			<div className="col-12 col-md-6 mt-3">
				<label for="entreprise_cpostal" className="form-label">Code postal*</label>
				<input className="form-control" type="text" name="cpostal" id="entreprise_cpostal" value={props.entrepriseCPostal} required="true" onChange={(e) => {props.setEntrepriseCPostal(e.target.value)}} pattern="[0-9]{5}" />
			</div>
		</div>
		</>
	)
}
const InformationsParticuler = (props) => {
	
	return (
		<>
		<div className="row">
			<div className="col-12 col-md-6 mt-3">
				<label for="particulier_nom" className="form-label">Nom*</label>
				<input className="form-control" type="text" name="nom" id="particulier_nom" value={props.particulierNom} required="true" onChange={(e) => {props.setParticulierNom(e.target.value)}} />
			</div>
			<div className="col-12 col-md-6 mt-3">
				<label for="particulier_prenom" className="form-label">Prénom*</label>
				<input className="form-control" type="text" name="prenom" id="particulier_prenom" value={props.particulierPrenom} required="true" onChange={(e) => {props.setParticulierPrenom(e.target.value)}} />
			</div>
		</div>
		<div className="row">
			<div className="col-12 col-md-6 mt-3">
				<label for="particulier_telephoneMobile" className="form-label">Téléphone*</label>
				<input className="form-control" type="tel" name="telephoneMobile" id="particulier_telephoneMobile" value={props.particulierTelephone} required="true" onChange={(e) => {props.setParticulierTelephone(e.target.value)}} pattern="^(?:0|\(?\+33\)?\s?|0033\s?)[1-79](?:[\.\-\s]?\d\d){4}$" />
			</div>
			<div className="col-12 col-md-6 mt-3">
				<label for="particulier_email" className="form-label">E-mail*</label>
				<input className="form-control" type="email" name="email" id="particulier_email" value={props.particulierEmail} required="true" onChange={(e) => {props.setParticulierEmail(e.target.value)}} pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" />
			</div>
		</div>
		<div className="row">
			<div className="col-12 col-md-6 mt-3">
				<label for="particulier_cpostal" className="form-label">Code postal*</label>
				<input className="form-control" type="text" name="cpostal" id="particulier_cpostal" value={props.particulierCPostal} required="true" onChange={(e) => {props.setParticulierCPostal(e.target.value)}} pattern="[0-9]{5}" />
			</div>
		</div>
		</>

	);

}

const BlocsFormulaire = (props) => {


	const renderSelectedForm = () => {
		if(props.typeFormulaire.key == 'ENTREPRISE'){
			return (
				<>
				<InformationsEntreprise 
					entrepriseNom={props.entrepriseNom} setEntrepriseNom={props.setEntrepriseNom}
					entreprisePrenom={props.entreprisePrenom} setEntreprisePrenom={props.setEntreprisePrenom}
					entrepriseTelephone={props.entrepriseTelephone} setEntrepriseTelephone={props.setEntrepriseTelephone}
					entrepriseEmail={props.entrepriseEmail} setEntrepriseEmail={props.setEntrepriseEmail}
					entrepriseSociete={props.entrepriseSociete} setEntrepriseSociete={props.setEntrepriseSociete} 
					entrepriseCPostal={props.entrepriseCPostal} setEntrepriseCPostal={props.setEntrepriseCPostal} 
				/>
				</>

			);
		}
		if(props.typeFormulaire.key == 'PARTICULIER'){
			return (
				<>
				<InformationsParticuler 
					particulierNom={props.particulierNom} setParticulierNom={props.setParticulierNom}
					particulierPrenom={props.particulierPrenom} setParticulierPrenom={props.setParticulierPrenom}
					particulierTelephone={props.particulierTelephone} setParticulierTelephone={props.setParticulierTelephone}
					particulierEmail={props.particulierEmail} setParticulierEmail={props.setParticulierEmail}
					particulierCPostal={props.particulierCPostal} setParticulierCPostal={props.setParticulierCPostal}
				/>
				</>

			);
		}
	}
	return (
		<>
		{renderSelectedForm()}
		<InformationsGenerales 
			objet={props.objet} setObjet={props.setObjet} 
			message={props.message} setMessage={props.setMessage} 
			accepteComCom={props.accepteComCom} setAccepteComCom={props.setAccepteComCom}  
			accepteRappel={props.accepteRappel} setAccepteRappel={props.setAccepteRappel}  

			selectedFormation={props.selectedFormation}
			selectedMode={props.selectedMode}
			typeFormulaire={props.typeFormulaire.key}
		/>
		</>

	);
	

}
const ReCaptchaComponent = (props) => {

	/*
	const { executeRecaptcha } = useGoogleReCaptcha();
	const handleReCaptchaVerify = useCallback(async (e) => {


		if (!executeRecaptcha) {
			console.log('Execute recaptcha not yet available');
			return;
		}
	
		const token = await executeRecaptcha(props.submit(e));


		// Do whatever you want with the token
	}, [executeRecaptcha]);
	// You can use useEffect to trigger the verification as soon as the component being loaded
	useEffect(() => {
		handleReCaptchaVerify();
	}, [handleReCaptchaVerify]);*/

	return (
		<>
		<button id="formSubmit" disabled={props.isButtonDisabled} type="submit" onClick={ (e) => { /*handleReCaptchaVerify(e)*/props.submit(e) } } className="btn btn-primary py-3">Envoyer ma demande</button>
		</>
	)
	

}
const Formulaire = (props) => {



    const [entrepriseNom, setEntrepriseNom] = useState('');
    const [entreprisePrenom, setEntreprisePrenom] = useState('');
    const [entrepriseTelephone, setEntrepriseTelephone] = useState('');
    const [entrepriseEmail, setEntrepriseEmail] = useState('');
    const [entrepriseSociete, setEntrepriseSociete] = useState('');
    const [entrepriseCPostal, setEntrepriseCPostal] = useState('');
    const [particulierNom, setParticulierNom] = useState('');
    const [particulierPrenom, setParticulierPrenom] = useState('');
    const [particulierTelephone, setParticulierTelephone] = useState('');
    const [particulierEmail, setParticulierEmail] = useState('');
    const [particulierCPostal, setParticulierCPostal] = useState('');


    const [objet, setObjet] = useState('');
    const [message, setMessage] = useState('');
    const [accepteComCom, setAccepteComCom] = useState(false);
    const [accepteRappel, setAccepteRappel] = useState(false);

    const [isButtonDisabled, setButtonDisabled] = useState(false);

	const [token, setToken] = useState("");
	const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

    useEffect(() => {
		if(accepteRappel){
			setButtonDisabled(false);
		}else{
			setButtonDisabled(true);
		}
  	}, [accepteRappel]);

    const disableButton = () => {
        setButtonDisabled(true);
    };
    const enableButton = () => {
        setButtonDisabled(false);
    };
	const submit = (e) => {
		if(!e){
			return;
		}
		e.preventDefault();

		disableButton()


		const demandeContact = document.querySelector("#demandeContact");
		if (! demandeContact.checkValidity()) {
			demandeContact.reportValidity()
			enableButton()
	  	}else{
			const url = props.baseUrl + '/wp-content/themes/eigroupe/forms/contact/contact.php';
			const fd = new FormData();

			if(props.typeFormulaire.key == 'ENTREPRISE'){
				fd.append('nom', entrepriseNom);
				fd.append('prenom', entreprisePrenom);
				fd.append('societe', entrepriseSociete);
				fd.append('email', entrepriseEmail);
				fd.append('telephoneMobile', entrepriseTelephone);
				fd.append('cpostal', entrepriseCPostal);
			}
			if(props.typeFormulaire.key == 'PARTICULIER'){
				fd.append('nom', particulierNom);
				fd.append('prenom', particulierPrenom);
				fd.append('email', particulierEmail);
				fd.append('telephoneMobile', particulierTelephone);
				fd.append('cpostal', particulierCPostal);
			}
			fd.append('objet', objet.key);
			fd.append('message', message);

			fd.append('type', props.typeFormulaire.key );
			fd.append('accepteComCom', accepteComCom);
			fd.append('origine', props.formOrigine);
			fd.append('token', props.formToken);
			
			axios.post(url,fd).then(function (response) {
				if ( response.status === 200 && response.data ) {
					const data = response.data;
					props.setFormSubmitted(true);
				}
			}).catch(function (error) {
				console.error( error );
			});
		}
	}
	const optionsTypeFormulaire = [
		{
			'key':"PARTICULIER",
			'label':"Un particulier"
		},
		{
			'key':"ENTREPRISE",
			'label':"Une entreprise"
		},
	]


    useEffect(() => {
		if(typeof props.typeFormulaire == 'string'){
			optionsTypeFormulaire.map((input, index) => {
				if(input.key == props.typeFormulaire){
					props.setTypeFormulaire(optionsTypeFormulaire[index])
				}
			})
		}
  	}, []);


	const HandleChangeType = (obj) => {
		props.setTypeFormulaire(obj)
		if(obj.key == 'PARTICULIER'){
			setAccepteRappel(false)
		}
	};


	return (
		<>
		<form id="demandeContact" method="post" onSubmit={ (e) => { submit(e) } }>


			<div className="row">
				<div className="col-12">
					<label for="particulier_nom" className="form-label">Vous êtes*</label>
					<Select
							onChange={(option) => HandleChangeType(option)}
							options={optionsTypeFormulaire}
							placeholder="Sélectionnez"
							value={props.typeFormulaire}
							defaultValue={props.typeFormulaire}
							getOptionValue={option => option.key}
							getOptionLabel={(option) => option.label}
							required={true}
							className="react-select-container"
							classNamePrefix="react-select"



						/>
				</div>
			</div>


			<BlocsFormulaire 
				typeFormulaire={props.typeFormulaire} setTypeFormulaire={props.setTypeFormulaire}

				entrepriseNom={entrepriseNom} setEntrepriseNom={setEntrepriseNom}
				entreprisePrenom={entreprisePrenom} setEntreprisePrenom={setEntreprisePrenom}
				entrepriseTelephone={entrepriseTelephone} setEntrepriseTelephone={setEntrepriseTelephone}
				entrepriseEmail={entrepriseEmail} setEntrepriseEmail={setEntrepriseEmail}
				entrepriseSociete={entrepriseSociete} setEntrepriseSociete={setEntrepriseSociete} 
				entrepriseCPostal={entrepriseCPostal} setEntrepriseCPostal={setEntrepriseCPostal} 

				particulierNom={particulierNom} setParticulierNom={setParticulierNom}
				particulierPrenom={particulierPrenom} setParticulierPrenom={setParticulierPrenom}
				particulierTelephone={particulierTelephone} setParticulierTelephone={setParticulierTelephone}
				particulierEmail={particulierEmail} setParticulierEmail={setParticulierEmail}
				particulierCPostal={particulierCPostal} setParticulierCPostal={setParticulierCPostal}

				objet={objet} setObjet={setObjet}
				message={message} setMessage={setMessage}  
				accepteComCom={accepteComCom} setAccepteComCom={setAccepteComCom} 
				accepteRappel={accepteRappel} setAccepteRappel={setAccepteRappel}  

				selectedFormation={props.selectedFormation}
				selectedMode={props.selectedMode}
				
				
			/>
			<hr className="mt-5" />
			<p className="text-end"><small><em>* Champs obligatoires</em></small></p>
			
			<div className='row'>
				<div className='col-12 pt-4'>
				<GoogleReCaptchaProvider 
					reCaptchaKey="6LfwkH0pAAAAAIK5jgNyUIPIhVvhV7XOh6GtzsZ1"
					language="fr_FR"
					>
					<ReCaptchaComponent
						className="google-recaptcha-custom-class"
						isButtonDisabled={isButtonDisabled}
						submit={submit}
					/>
				</GoogleReCaptchaProvider>
				</div>
			</div>
			
			
		</form>
		</>
	)
}
const App = () => {
	var _defaultType = document.getElementById('gei_contact_form').getAttribute('data-type');
	var _formOrigine = document.getElementById('gei_contact_form').getAttribute('data-origine');
	var _formToken = document.getElementById('gei_contact_form').getAttribute('data-token');
	var _baseUrl = document.getElementById('gei_contact_form').getAttribute('data-url');

	var _selectedFormation = document.getElementById('gei_contact_form').getAttribute('data-formation');
	var _selectedMode = document.getElementById('gei_contact_form').getAttribute('data-mode');

    const [typeFormulaire, setTypeFormulaire] = useState(_defaultType);

    const [formSubmitted, setFormSubmitted] = useState(false);

	//console.log('Formation : ',_selectedFormation);
	//console.log('Mode : ',_selectedMode);
	if(formSubmitted){
		return(
			<>
			<div className='container formulaire'>
				<div className="success-msg">Demande envoyée avec succès</div>
				<p className="mt-5 text-center fs-6">Elle sera traîtée dans les plus brefs délais et nous reviendrons vers vous dès que possible.</p>
			</div>
			</>
		)
	}
	return (
		<>
		<div className='container p-0'>
			<Formulaire
				baseUrl={_baseUrl}
				typeFormulaire={typeFormulaire} setTypeFormulaire={setTypeFormulaire}
				selectedFormation={_selectedFormation}
				selectedMode={_selectedMode}
				formOrigine={_formOrigine}
				formToken={_formToken}
				formSubmitted={formSubmitted} setFormSubmitted={setFormSubmitted}
			/>
		</div>
		</>
	);
}
export default App;

